<div class="innerBanner" (click)="imageClick(0)" style="background-image: url('{{ contactDetails.bannerImage }}')">
  <!-- <img
      [src]="contactDetails.bannerImage ? contactDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
      style="width: 100%"
    /> -->
  <div class="bannerText">
    <h1>{{ contactDetails.bannerTitle }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>
<body class="frequentlyquestions-page">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{ contactDetails.bannerTitle }}</li>
    </ol>
  </nav>
</body>
<div class="container">
  <div class="contentPanel">
    <div class="pageTitle"></div>
  </div>
  <h1 class="text-center">{{ 'Contact-FAQs' | translate }}</h1>
  <div *ngFor="let faq of freqAskQues; let i = index">
    <p-accordion class="faq">
      <p-accordionTab header="{{ i + 1 }}   {{ faq.question }}"> {{ faq.answer }} </p-accordionTab>
    </p-accordion>
  </div>
</div>
